import { CardJobs } from './CardJobs';
import { CardShow } from './CardShow';
import { CardCreate } from './CardCreate';
import type { Card } from '@/types';

export default {
    list: CardJobs,
    show: CardShow,
    create: CardCreate,
    recordRepresentation: (record: Card) => record?.title || `Card #${record?.id ?? ''}`,
};
